/**
 * Generic confirmation modal handler
 * 
 * This script handles the functionality for confirmation modals across the application.
 * It populates modal content and form action URLs based on attributes from the trigger element.
 */

document.addEventListener('turbo:load', function() {
  setupModalHandlers();
});

document.addEventListener('DOMContentLoaded', function() {
  setupModalHandlers();
});

function setupModalHandlers() {
  // Find all confirmation modals in the document
  const confirmationModals = document.querySelectorAll('.modal');
  
  confirmationModals.forEach(modal => {
    // Clear existing event listeners to prevent duplication
    const newModal = modal.cloneNode(true);
    if (modal.parentNode) {
      modal.parentNode.replaceChild(newModal, modal);
    }
    
    // Set up the show event handler for each modal
    newModal.addEventListener('show.bs.modal', function(event) {
      // Get the button that triggered the modal
      const button = event.relatedTarget;
      if (!button) return;
      
      const modalId = newModal.id;
      
      // Get the target ID and display text from the trigger button
      const idAttribute = button.getAttribute('data-item-id');
      
      if (idAttribute) {
        // Get the form element and update its action URL
        const form = document.getElementById(`${modalId}Form`);
        if (form) {
          const basePath = button.getAttribute('data-base-path') || '';
          form.action = `${basePath}/${idAttribute}`;
        }
      }
      
    });
  });
}
